export enum DNVReportStatus {
    VoyageOngoing = 0,
    InternalControlIssues = 1,
    ReadyForVerification = 2,
    SentToDNV = 3,
    DNVIssues = 4,
    VerifiedByDNV = 5,
    NewVersionAvailable = 6,
}
